import { numberOfItemsSelector } from 'basket/selectors'

import shoppingIconPath from '../icons/ic-shopping.svg'
import shoppingIconActivePath from '../icons/ic-shopping-active.svg'
import IconLink from './IconLink'

const BasketContainer = ({ translate, basketNumberOfItems }) => (
    <div className="basket-link">
        <IconLink
            alt={translate('header.basket.icon.tooltip')}
            iconPath={shoppingIconPath}
            iconActivePath={shoppingIconActivePath}
            url="basket"
            basketNumberOfItems={basketNumberOfItems}
        />
    </div>
)

export default compose(
    connect(
        createStructuredSelector({
            basketNumberOfItems: numberOfItemsSelector,
        })
    ),
    withTranslate
)(BasketContainer)
